// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup-success button.button-style-5[data-v-2988d48a] {\n    margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
